import React from "react";
// import { Link } from 'react-router-dom';
import {renderWhatsappButton,renderPhoneButton,renderSmsButton } from "../functions/Functions";

// import {
//   Icon,
//   //Button,
// } from "semantic-ui-react";

const PhoneWhatsappButton = () => {
const message = '';
  const phone = '9910223322';
  //*************** */
  return (
    
      
          <div 
          style={{position:'fixed', bottom:'50px',right:'15px',}}
          >
        <div>
        {renderWhatsappButton(phone,message)}
        </div>
        <div className="mt-05">
        {renderPhoneButton(phone)}
        </div>
        <div className="mt-05">
        {renderSmsButton(phone,message )}
        </div>
        
       

          </div>
          
   
  );

};

export default PhoneWhatsappButton;
